import { Routes, RouterModule } from '@angular/router';
import { AddressComponent } from './address.component';

const routes: Routes = [
    {
        path: '',
        component: AddressComponent
    },
];

export const AddressRoutes = RouterModule.forChild(routes);
